import React from 'react';

import { Accent, Box, Text } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';

import { Article } from '~/generated-graphql/generated-types';
import { trackInteraction } from '~/client/lib/analytics-helpers';
import { HOMEPAGE as analyticsBase } from '~/client/lib/analytics-constants';
import NewsArticlesAuthor from '../news-articles-author/news-articles-author';
import styles from './news-articles-hero.module.less';

type NewsArticlesHeroProps = {
  article: Article;
};

const NewsArticlesHero = ({ article }: NewsArticlesHeroProps): JSX.Element => (
  <Box display="flex" flexDirection="column">
    <Box marginBottom="3" className={styles.accentWrapper}>
      <Accent>Top Story</Accent>
    </Box>
    <a
      className={styles.articleLink}
      href={article?.link}
      onClick={() =>
        trackInteraction({
          entityName: `breaking_news_feed_featured_${article.id}`,
          sectionName: analyticsBase.section_name,
          action: 'select',
        })
      }
    >
      <Image alt="" src={article?.featuredMedia?.sourceUrl ?? ''} lazy />
      <Box marginTop="3">
        <Text size="large" bold className={styles.articleTitle}>
          {article?.title}
        </Text>
      </Box>
    </a>
    <Box marginTop="2">
      <NewsArticlesAuthor
        avatarUrl={article?.authors?.[0]?.avatarUrls?.[0]?.url}
        authorUrl={article?.authors?.[0]?.link}
        name={article?.authors?.[0]?.name ?? 'NerdWallet'}
      />
    </Box>
  </Box>
);

NewsArticlesHero.displayName = 'NewsArticlesHero';

export default NewsArticlesHero;
